import { connect } from 'react-redux';
import { Country } from '~/Api/Country';
import FilterParameter from '~/libs/FilterParameter/FilterParameter';
import { Query } from '~/Product';
import { State as ProductPriceState } from '~/ProductPrice';
import buildProductSearchUrl from '~/Router/buildProductSearchUrl';

import EmptyRow from './EmptyRow';

function mapStateToProps(
	state: { productPrice: ProductPriceState },
	props: { country: Country | null }
): { link: { pathname: string; search: string } } {
	const { country } = props;

	return {
		link: buildProductSearchUrl(
			new Query([new FilterParameter('country', country?.alpha2 || '')]),
			null,
			state.productPrice.priceTypePreference.load()
		),
	};
}

export default connect(mapStateToProps)(EmptyRow);
